import React, { Suspense, useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { getLocalStorage } from "../utils/function/localStorage";
import { routers } from "./_routers";
import "../components/Pending/_pending.scss";
import { useGetLoginUserQuery } from "../services/userApi";

const AppContent = () => {
  const { data } = useGetLoginUserQuery();
  const navigate = useNavigate();
  const token = getLocalStorage("tp_Aa_uth_access");
  useEffect(() => {
    if (!token) {
      navigate("/");
    }
  }, [navigate, token]);

  const perRoute = routers?.filter((rt) =>
    rt?.permission?.includes(data?.data?.role)
  );
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Suspense
        fallback={
          <div style={{ width: '100%', height: '3px', overflow: 'hidden', background: 'rgba(0,0,0,0.05)', pointerEvents: 'none' }}>
            <style>{`@keyframes tp-refresh-slide{0%{left:-40%}100%{left:100%}}`}</style>
            <div style={{
              position: 'relative',
              width: '40%', height: '100%',
              background: 'linear-gradient(90deg, #45bbff, #0b59f9, #45bbff)',
              borderRadius: '2px',
              animation: 'tp-refresh-slide 1.2s ease-in-out infinite',
            }} />
          </div>
        }
      >
        <Routes>
          <>
            {perRoute?.map((route, idx) => {
              return (
                route.component && (
                  <Route
                    key={idx}
                    path={route.path}
                    exact={route.exact}
                    name={route.name}
                    element={<route.component />}
                  />
                )
              );
            })}
          </>
        </Routes>
      </Suspense>
    </>
  );
};

export default AppContent;
